<script>
  // Перенос SlotTabs из parts.tsx — чипы-табы (слоты одежды, категории).
  import Ico from '../ico.svelte';
  export let items = [];
  export let active = '';
  export let onChange = () => {};
</script>

<div class="mn-slots">
  {#each items as it (it.id)}
    <div class={'mn-slot' + (it.id === active ? ' on' : '')} on:click={() => onChange(it.id)}>
      {#if it.icon}<Ico n={it.icon} s={15} />{/if}{it.label}{#if it.n != null}<span class="n">{it.n}</span>{/if}
    </div>
  {/each}
</div>
